import desktopGarden from '../sound-hunt/classroomTrainGardenApproved.webp';
import mobileGarden from '../sound-hunt/classroomTrainGardenMobileApproved.webp';

// The live game and opening screen use the same CSS image URLs. Decode the
// matching asset before swapping the loading dialog for the playable train,
// so a very fast API response cannot briefly reveal the fallback background.
// Keep CSS references and these imports synchronized if artwork is replaced.
const decoded = new Map();

export function classroomTrainBackdropUrl(width = (typeof window === 'undefined' ? 1280 : window.innerWidth)) {
  return Number(width) <= 700 ? mobileGarden : desktopGarden;
}

export function prepareClassroomTrainBackdrop(width) {
  const url = classroomTrainBackdropUrl(width);
  if (decoded.has(url)) return decoded.get(url);
  if (typeof Image === 'undefined') return Promise.resolve();

  const img = new Image();
  img.src = url;
  // JSDOM/older browsers lack decode. Avoid blocking the game indefinitely.
  if (typeof img.decode !== 'function') return Promise.resolve();
  const ready = img.decode().catch(() => {
    // Broken-image handling belongs to the game/asset QA; never lock children
    // out of the activity if the decorative backdrop cannot load.
  });
  decoded.set(url, ready);
  return ready;
}
